import { createContext } from "react";

import { AbilityObject } from "./config";

export const AbilityContext = createContext<AbilityObject[] | undefined>(
  undefined,
);
